import { render, staticRenderFns } from "./RolesMain.vue?vue&type=template&id=ea8f8168&scoped=true&"
import script from "./RolesMain.vue?vue&type=script&lang=js&"
export * from "./RolesMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea8f8168",
  null
  
)

export default component.exports